export default {
  init() {


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(window).on('load', function () {
      $('.owl-carousel-01').owlCarousel({
        loop: true,
        margin: 30,
        dots: false,
        stopOnHover: true,
        nav: false,
        autoplay: false,
        smartSpeed: 1000,
        autoplayTimeout: 7000,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
          1000: {
            items: 3,
          },
        },
      });

      //Init the carousel

      $('.owl-carousel-02').owlCarousel({
        items: 1,
        loop: true,
        autoWidth: false,
        onInitialized: startProgressBar,
        onTranslate: resetProgressBar,
        onTranslated: startProgressBar,
        margin: 10,
        dots: false,
        stopOnHover: false,
        nav: false,
        autoplay: true,
        smartSpeed: 2000,
        autoplayTimeout: 7000,
        singleItem: true,
        center: true,

        responsive: {
          0: {
            items: 1,
            stagePadding: 0,
          },
          600: {
            items: 1,
            stagePadding: 50,
          },
          1000: {
            items: 1,
            stagePadding: 150,
          },
          1400: {
            stagePadding: 350,
          },
          1920: {
            stagePadding: 350,
          },
        },

      });


      function startProgressBar() {
        // apply keyframe animation

        $('.slide-progress').css({
          width: '100%',
          transition: 'width 5000ms',
        });
      }

      function resetProgressBar() {
        $('.slide-progress').css({
          width: 0,
          transition: 'width 0s',
        });
      }
      $('.customNextBtn, .p-customNextBtn').click(function () {
        owl.trigger('next.owl.carousel');
      });


      // Go to the previous item
      $('.customPrevBtn, .p-customPrevBtn').click(function () {
        // With optional speed parameter
        // Parameters has to be in square bracket '[]'
        owl.trigger('prev.owl.carousel', [300]);
      });

      // function counter(event) {
      //   var items = event.item.count; // Number of items
      //   var item = event.item.index + 1; // Position of the current item

      //   // it loop is true then reset counter from 1
      //   if (item > items) {
      //     item = item - items;
      //   }
      //   // $('#counter1 .currentCounter').html(item);
      //   // $('#counter1 .maxCounter').html(items);
      //   // $('#counter2').html((item + 1) + ' | ' + items);
      //   // $('#counter3').html((item + 2) + ' | ' + items);
      // }


    });
    var owl = $('.owl-carousel');



    //   function startCounting(){
    //     (function ($) {
    //       $.fn.countTo = function (options) {
    //         options = options || {};

    //         return $(this).each(function () {
    //           // set options for current element
    //           var settings = $.extend({}, $.fn.countTo.defaults, {
    //             from: $(this).data('from'),
    //             to: $(this).data('to'),
    //             speed: $(this).data('speed'),
    //             refreshInterval: $(this).data('refresh-interval'),
    //             decimals: 2,
    //           }, options);

    //           // how many times to update the value, and how much to increment the value on each update
    //           var loops = Math.ceil(settings.speed / settings.refreshInterval),
    //             increment = (settings.to - settings.from) / loops;

    //           // references & variables that will change with each update
    //           var self = this,
    //             $self = $(this),
    //             loopCount = 0,
    //             value = settings.from,
    //             data = $self.data('countTo') || {};

    //           $self.data('countTo', data);

    //           // if an existing interval can be found, clear it first
    //           if (data.interval) {
    //             clearInterval(data.interval);
    //           }
    //           data.interval = setInterval(updateTimer, settings.refreshInterval);

    //           // initialize the element with the starting value
    //           render(value);

    //           function updateTimer() {
    //             value += increment;
    //             loopCount++;

    //             render(value);

    //             if (typeof (settings.onUpdate) == 'function') {
    //               settings.onUpdate.call(self, value);
    //             }

    //             if (loopCount >= loops) {
    //               // remove the interval
    //               $self.removeData('countTo');
    //               clearInterval(data.interval);
    //               value = settings.to;

    //               if (typeof (settings.onComplete) == 'function') {
    //                 settings.onComplete.call(self, value);
    //               }
    //             }
    //           }

    //           function render(value) {
    //             var formattedValue = settings.formatter.call(self, value, settings);
    //             $self.html(formattedValue);
    //           }
    //         });
    //       };

    //       $.fn.countTo.defaults = {
    //         from: 0, // the number the element should start at

    //         speed: 2000, // how long it should take to count between the target numbers
    //         refreshInterval: 100, // how often the element should be updated
    //         decimals: 2, // the number of decimal places to show
    //         formatter: formatter, // handler for formatting the value before rendering
    //         onUpdate: null, // callback method for every time the element is updated
    //         onComplete: null, // callback method for when the element finishes updating
    //       };

    //       function formatter(value, settings) {
    //         return value.toFixed(settings.decimals);
    //       }
    //     }(jQuery));

    //     //Does something when user scrolls to it OR
    //     //Does it when user has reached the bottom of the page and hasn't triggered the function yet

    //     jQuery(function ($) {
    //       // custom formatting example
    //       $('.count_bn, .count_mt').data('countToOptions', {
    //         formatter: function (value, options) {
    //           return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
    //         },
    //       });

    //       // start all the timers
    //       $('.count_bn, .count_mt').each(count);

    //       function count(options) {
    //         var $this = $(this);
    //         options = $.extend({}, options || {}, $this.data('countToOptions') || {});
    //         $this.countTo(options);
    //       }
    //     });





    //   }

    //   function startCountingTwo(){
    //     (function ($) {
    //       $.fn.countTo = function (options) {
    //         options = options || {};

    //         return $(this).each(function () {
    //           // set options for current element
    //           var settings = $.extend({}, $.fn.countTo.defaults, {
    //             from: $(this).data('from'),
    //             to: $(this).data('to'),
    //             speed: $(this).data('speed'),
    //             refreshInterval: $(this).data('refresh-interval'),
    //             decimals: $(this).data('decimals'),
    //           }, options);

    //           // how many times to update the value, and how much to increment the value on each update
    //           var loops = Math.ceil(settings.speed / settings.refreshInterval),
    //             increment = (settings.to - settings.from) / loops;

    //           // references & variables that will change with each update
    //           var self = this,
    //             $self = $(this),
    //             loopCount = 0,
    //             value = settings.from,
    //             data = $self.data('countTo') || {};

    //           $self.data('countTo', data);

    //           // if an existing interval can be found, clear it first
    //           if (data.interval) {
    //             clearInterval(data.interval);
    //           }
    //           data.interval = setInterval(updateTimer, settings.refreshInterval);

    //           // initialize the element with the starting value
    //           render(value);

    //           function updateTimer() {
    //             value += increment;
    //             loopCount++;

    //             render(value);

    //             if (typeof (settings.onUpdate) == 'function') {
    //               settings.onUpdate.call(self, value);
    //             }

    //             if (loopCount >= loops) {
    //               // remove the interval
    //               $self.removeData('countTo');
    //               clearInterval(data.interval);
    //               value = settings.to;

    //               if (typeof (settings.onComplete) == 'function') {
    //                 settings.onComplete.call(self, value);
    //               }
    //             }
    //           }

    //           function render(value) {
    //             var formattedValue = settings.formatter.call(self, value, settings);
    //             $self.html(formattedValue);
    //           }
    //         });
    //       };

    //       $.fn.countTo.defaults = {
    //         from: 0, // the number the element should start at

    //         speed: 2000, // how long it should take to count between the target numbers
    //         refreshInterval: 100, // how often the element should be updated
    //         decimals: 0, // the number of decimal places to show
    //         formatter: formatter, // handler for formatting the value before rendering
    //         onUpdate: null, // callback method for every time the element is updated
    //         onComplete: null, // callback method for when the element finishes updating
    //       };

    //       function formatter(value, settings) {
    //         return value.toFixed(settings.decimals);
    //       }
    //     }(jQuery));

    //     //Does something when user scrolls to it OR
    //     //Does it when user has reached the bottom of the page and hasn't triggered the function yet

    //     jQuery(function ($) {
    //       // custom formatting example
    //       $('.count-p, .count_mw').data('countToOptions', {
    //         formatter: function (value, options) {
    //           return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
    //         },
    //       });

    //       // start all the timers
    //       $('.count-p, .count_mw').each(count);

    //       function count(options) {
    //         var $this = $(this);
    //         options = $.extend({}, options || {}, $this.data('countToOptions') || {});
    //         $this.countTo(options);
    //       }
    //     });





    //   }

    //   $(window).on('scroll',function() {

    //     if ($('#scrollingNumbers').length > 0){

    //         // div exists
    //     var hT = $('#scrollingNumbers').offset().top,
    //         hH = $('#scrollingNumbers').outerHeight(),
    //         wH = $(window).height(),
    //         wS = $(this).scrollTop();

    //     if (wS > ((hT+hH-wH)-500)){
    //         // After Stuff
    //         $(window).off('scroll');
    //         startCounting();
    //         startCountingTwo();
    //     }
    //   }
    // });

    //   $(window).scroll(function () {
    //     if ($(this).scrollTop() > 40) {
    //       $('.navbar').addClass('fixed-top');
    //       // add padding top to show content behind navbar
    //       $('body').css('padding-top', $('.navbar').outerHeight() + 'px');
    //     } else {
    //       $('.navbar').removeClass('fixed-top');
    //       // remove padding top from body
    //       $('body').css('padding-top', '0');
    //     }
    //   });


    $(document).ready(function () {
      window.dispatchEvent(new Event('resize'));


      $('.navbar-light .dmenu').hover(function () {
        $(this).find('.sm-menu').first().stop(true, true).addClass('showMe').fadeIn();

      }, function () {
        $(this).find('.sm-menu').first().stop(true, true).fadeOut();


      });
      $(document).ready(function () {
        $('.sm-menu').on('click', function (e) {
          e.stopPropagation();
        });

      });

    });

    /**/

    function startCounting() {
      (function ($) {
        $.fn.countTo = function (options) {
          options = options || {};
          return $(this).each(function () {
            var settings = $.extend({}, $.fn.countTo.defaults, {
              from: $(this).data('from'),
              to: $(this).data('to'),
              speed: $(this).data('speed'),
              refreshInterval: $(this).data('refresh-interval'),
              decimals: $(this).data('decimals'),
            }, options);
            var loops = Math.ceil(settings.speed / settings.refreshInterval),
              increment = (settings.to - settings.from) / loops;
            var self = this,
              $self = $(this),
              loopCount = 0,
              value = settings.from,
              data = $self.data('countTo') || {};
            $self.data('countTo', data);
            if (data.interval) {
              clearInterval(data.interval);
            }
            data.interval = setInterval(updateTimer, settings.refreshInterval);
            render(value);

            function updateTimer() {
              value += increment;
              loopCount++;
              render(value);
              if (typeof (settings.onUpdate) == 'function') {
                settings.onUpdate.call(self, value);
              }
              if (loopCount >= loops) {
                $self.removeData('countTo');
                clearInterval(data.interval);
                value = settings.to;
                if (typeof (settings.onComplete) == 'function') {
                  settings.onComplete.call(self, value);
                }
              }
            }

            function render(value) {
              var formattedValue = settings.formatter.call(self, value, settings);
              $self.html(formattedValue);
            }
          });
        };
        $.fn.countTo.defaults = {
          from: 0,
          speed: 2000,
          refreshInterval: 100,
          decimals: 2,
          formatter: formatter,
          onUpdate: null,
          onComplete: null,
        };

        function formatter(value, settings) {
          return value.toFixed(settings.decimals);
        }
      }(jQuery));
      jQuery(function ($) {
        $('.count_bn, .count_mt').data('countToOptions', {
          formatter: function (value, options) {
            return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
          },
        });
        $('.count_bn, .count_mt').each(count);

        function count(options) {
          var $this = $(this);
          options = $.extend({}, options || {}, $this.data('countToOptions') || {});
          $this.countTo(options);
        }
      });
    }

    function startCountingTwo() {
      (function ($) {
        $.fn.countTo = function (options) {
          options = options || {};
          return $(this).each(function () {
            var settings = $.extend({}, $.fn.countTo.defaults, {
              from: $(this).data('from'),
              to: $(this).data('to'),
              speed: $(this).data('speed'),
              refreshInterval: $(this).data('refresh-interval'),
              decimals: $(this).data('decimals'),
            }, options);
            var loops = Math.ceil(settings.speed / settings.refreshInterval),
              increment = (settings.to - settings.from) / loops;
            var self = this,
              $self = $(this),
              loopCount = 0,
              value = settings.from,
              data = $self.data('countTo') || {};
            $self.data('countTo', data);
            if (data.interval) {
              clearInterval(data.interval);
            }
            data.interval = setInterval(updateTimer, settings.refreshInterval);
            render(value);

            function updateTimer() {
              value += increment;
              loopCount++;
              render(value);
              if (typeof (settings.onUpdate) == 'function') {
                settings.onUpdate.call(self, value);
              }
              if (loopCount >= loops) {
                $self.removeData('countTo');
                clearInterval(data.interval);
                value = settings.to;
                if (typeof (settings.onComplete) == 'function') {
                  settings.onComplete.call(self, value);
                }
              }
            }

            function render(value) {
              var formattedValue = settings.formatter.call(self, value, settings);
              $self.html(formattedValue);
            }
          });
        };
        $.fn.countTo.defaults = {
          from: 0,
          speed: 2000,
          refreshInterval: 100,
          decimals: 0,
          formatter: formatter,
          onUpdate: null,
          onComplete: null,
        };

        function formatter(value, settings) {
          return value.toFixed(settings.decimals);
        }
      }(jQuery));
      jQuery(function ($) {
        $('.count-p, .count_mw').data('countToOptions', {
          formatter: function (value, options) {
            return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
          },
        });
        $('.count-p, .count_mw').each(count);

        function count(options) {
          var $this = $(this);
          options = $.extend({}, options || {}, $this.data('countToOptions') || {});
          $this.countTo(options);
        }
      });
    }
    $(window).on('scroll', function () {
      if ($('#scrollingNumbers').length > 0) {
        var hT = $('#scrollingNumbers').offset().top,
          hH = $('#scrollingNumbers').outerHeight(),
          wH = $(window).height(),
          wS = $(this).scrollTop();
        if (wS > ((hT + hH - wH) - 500)) {
          $(window).off('scroll');
          startCounting();
          startCountingTwo();
        }
      }
    });
    jQuery(document).ready(function () {
      $('.container2, .container3').fadeOut();
      var back = jQuery('.prev');
      var next = jQuery('.next');
      var steps = jQuery('.step');

      next.bind('click', function () {
        jQuery.each(steps, function (i) {
          if (!jQuery(steps[i]).hasClass('current') && !jQuery(steps[i]).hasClass('done')) {
            jQuery(steps[i]).addClass('current');
            jQuery(steps[i - 1]).removeClass('current').addClass('done');
            return false;
          }

        })
        if ($('.step01').hasClass('current')) {
          $('.container2, .container3').fadeOut();
          $('.container1').fadeIn()
        } else if ($('.step02').hasClass('current')) {
          $('.container1, .container3').fadeOut();
          $('.container2').fadeIn()
        } else if ($('.step03').hasClass('current')) {
          $('.container1, .container2').fadeOut();
          $('.container3').fadeIn()
        }
      });
      back.bind('click', function () {
        jQuery.each(steps, function (i) {
          if (jQuery(steps[i]).hasClass('done') && jQuery(steps[i + 1]).hasClass('current')) {
            jQuery(steps[i + 1]).removeClass('current');
            jQuery(steps[i]).removeClass('done').addClass('current')

            return false;

          }
          if ($('.step01').hasClass('current')) {
            console.log('current-container: ')
            $('.container1').fadeIn();
            $('.container2').fadeOut()
          } else if ($('.step02').hasClass('current')) {
            $('.container1').fadeIn();
            $('.container2').fadeOut()
          } else if ($('.step03').hasClass('current')) {
            $('.container2').fadeIn();
            $('.container3').fadeOut()
          }
        })

      });

    })


    // SmartWizard initialize
    $('#smartwizard').smartWizard({
      selected: 0, // Initial selected step, 0 = first step
      theme: 'arrows', // theme for the wizard, related css need to include for other than default theme
      justified: true, // Nav menu justification. true/false
      darkMode: false, // Enable/disable Dark Mode if the theme supports. true/false
      autoAdjustHeight: true, // Automatically adjust content height
      cycleSteps: false, // Allows to cycle the navigation of steps
      backButtonSupport: true, // Enable the back button support
      enableURLhash: false, // Enable selection of the step based on url hash
      transition: {
        animation: 'none', // Effect on navigation, none/fade/slide-horizontal/slide-vertical/slide-swing
        speed: '145', // Transion animation speed
        easing: '', // Transition animation easing. Not supported without a jQuery easing plugin
      },
      toolbarSettings: {
        toolbarPosition: 'bottom', // none, top, bottom, both
        toolbarButtonPosition: 'right', // left, right, center
        showNextButton: true, // show/hide a Next button
        showPreviousButton: true, // show/hide a Previous button
        toolbarExtraButtons: [], // Extra buttons to show on toolbar, array of jQuery input/buttons elements
      },
      anchorSettings: {
        anchorClickable: true, // Enable/Disable anchor navigation
        enableAllAnchors: true, // Activates all anchors clickable all times
        markDoneStep: true, // Add done state on navigation
        markAllPreviousStepsAsDone: true, // When a step selected by url hash, all previous steps are marked done
        removeDoneStepOnNavigateBack: false, // While navigate back done step after active step will be cleared
        enableAnchorOnDoneStep: true, // Enable/Disable the done steps navigation
      },
      keyboardSettings: {
        keyNavigation: true, // Enable/Disable keyboard navigation(left and right keys are used if enabled)
        keyLeft: [37], // Left key code
        keyRight: [39], // Right key code
      },
      lang: { // Language variables for button
        next: 'Next',
        previous: 'Previous',
      },
      disabledSteps: [], // Array Steps disabled
      errorSteps: [], // Highlight step with errors
      hiddenSteps: [], // Hidden steps
    });


    $('.sw-btn-next').on('click', function () {
      if ($(window).width() < 767) {
        setTimeout(
          $('html, body').scrollTop($('#smartwizard').offset().top - 180), 150);
      } else {
        setTimeout(
          $('html, body').scrollTop($('#smartwizard').offset().top - 180), 150);
      }

    });
    $('.sw-btn-prev').on('click', function () {
      if ($(window).width() < 767) {
        setTimeout(
          $('html, body').scrollTop($('#smartwizard').offset().top - 180), 150);
      } else {
        setTimeout(
          $('html, body').scrollTop($('#smartwizard').offset().top - 180), 150);
      }
    });

    $('#open-sidebar-menu').on('click', function () {

      $('body').toggleClass('menu-open');
      $('body').toggleClass('noscroll');
    });

    $('.close-overlay').on('click', function () {
      $('body').removeClass('menu-open');
      $('body').removeClass('noscroll');
    });


    // scroll menu

    // Hide Header on on scroll down
    (function () {

      var doc = document.documentElement;
      var w = window;

      var prevScroll = w.scrollY || doc.scrollTop;
      var curScroll;
      var direction = 0;
      var prevDirection = 0;

      var header = $('.navbar');

      var checkScroll = function () {

        /*
         ** Find the direction of scroll
         ** 0 - initial, 1 - up, 2 - down
         */

        curScroll = w.scrollY || doc.scrollTop;
        if (curScroll > prevScroll) {
          //scrolled up
          // console.log('scrolled up');
          direction = 2;
        } else if (curScroll < prevScroll) {
          //scrolled down
          // console.log('scrolled down');
          direction = 1;
        }

        if (direction !== prevDirection) {
          toggleHeader(direction, curScroll);
        }

        prevScroll = curScroll;
      };

      var toggleHeader = function (direction, curScroll) {
        if (direction === 2 && curScroll > 52) {

          //replace 52 with the height of your header in px

          header.addClass('shrink');
          $('.nav-bar_top').addClass('hide-top');
          prevDirection = direction;
        } else if (direction === 1) {
          header.removeClass('shrink');
          $('.nav-bar_top').removeClass('hide-top');
          prevDirection = direction;
        }
      };

      window.addEventListener('scroll', checkScroll);

    })();


  },


};



// WEBPACK FOOTER //
// ./scripts/routes/common.js